// Module
var code = "<div> <div class=\"main row\"> <div class=\"page-header\"> <h2>Gestion des transporteurs <div class=\"pull-right\"> <button class=\"btn btn-primary\" ng-click=\"openAddModalTemplate()\"> <span class=\"glyphicon glyphicon-plus\"></span> </button> </div> </h2> </div> </div> </div> ";
// Exports
export default code;